import { render } from "./hotel.vue?vue&type=template&id=6873fdd4&scoped=true"
import script from "./hotel.vue?vue&type=script&lang=js"
export * from "./hotel.vue?vue&type=script&lang=js"

import "./hotel.vue?vue&type=style&index=0&id=6873fdd4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6873fdd4"

export default script